import { createContext } from 'react';
import { GUEST_REGISTRY_INITIAL_STATE } from './GuestRegistry.provider';

const GuestRegistryContext = createContext(GUEST_REGISTRY_INITIAL_STATE);

export { GuestRegistryContext };
